import { flagCodeForCompetition } from '../lib/competitionFlags.js';
import styles from './CompetitionFlag.module.css';

/**
 * The little flag beside a competition's name — same idea as `TeamBadge`,
 * but keyed off `competitions.slug` rather than a team row, since a
 * competition's flag is a fixed fact about the competition itself (see
 * `competitionFlags.ts`), not something the API needs to report per bolão.
 *
 * Deliberately an `<img>` (flagcdn.com), not the flag emoji baked into
 * `displayName` text: emoji flags render fine in ordinary page text, but
 * Windows' native `<select>`/`<option>` control can't render the
 * multi-codepoint flag sequences at all — it falls back to showing the raw
 * two-letter region code. An image has no such gap.
 */
export default function CompetitionFlag({ slug }: { slug: string }) {
  const flagCode = flagCodeForCompetition(slug);
  if (!flagCode) return null;
  return <img className={styles.flag} src={`https://flagcdn.com/24x18/${flagCode}.png`} alt="" />;
}
